import { HttpService } from './HttpService';
import { PowerplantModel } from 'models/PowerplantModel';

export class PowerplantService {
  static baseUrl = '/frontend/context-manager';

  static async getPowerplant(powerplantId: string): Promise<PowerplantModel> {
    return HttpService.get(`${PowerplantService.baseUrl}/context/plant?id=${powerplantId}`);
  };

  static async getPowerplants(): Promise<PowerplantModel[]> {
    return HttpService.get(`${PowerplantService.baseUrl}/context/plants`);
  };
}
